import React from 'react'
import { TextInput } from 'react-admin'

const CustomerFilters = 
[
  <TextInput source='companyName_Contains' label='resources.filter.companyNameContains' alwaysOn resettable />,
  <TextInput source='contactEmail_Contains' label='resources.filter.contactEmailContains' alwaysOn resettable />,
]

export default CustomerFilters